var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCulturasAgricolas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    transform: "translate(4527 -215)",
    fill: "#36364a",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "b",
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4527 215)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4527 -214.934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.491,20.647A14.923,14.923,0,0,0,7.643,18.2,15.422,15.422,0,0,0,1.8,18.095c-.425,0-.851,0-.957-.425,0-.638.319-.744.851-.744A16.764,16.764,0,0,1,14.342,19.8a.806.806,0,0,0,1.063,0A10.73,10.73,0,0,1,17,19.052a14.737,14.737,0,0,0-3.3-2.445A19.911,19.911,0,0,0,2.114,14.48c-.532,0-1.063.319-1.276-.425-.106-.425.213-.744,1.17-.744a19.9,19.9,0,0,1,14.248,3.509c.532.425,1.063.957,1.595,1.382a.813.813,0,0,0,.957.213,36.215,36.215,0,0,1,13.4-2.233h.425c.213.213.532.425.532.638s-.319.425-.532.532h-.851c-12.015.106-21.69,5-29.133,14.354a2.315,2.315,0,0,0-.532.851c-.213.319-.532.638-.957.319s-.319-.638,0-1.063c1.063-1.276,2.02-2.445,3.083-3.721.106-.213.319-.319.532-.532a3.2,3.2,0,0,0-2.764-.425c-.425,0-.851.106-.957-.425s.213-.744.744-.851A5.132,5.132,0,0,1,5.73,26.6c1.063-.851,2.02-1.7,3.083-2.658A9.91,9.91,0,0,0,5.092,22.56c-1.063-.106-2.127-.106-3.083-.106-.425,0-.851,0-.851-.532s.319-.638.744-.744a12.023,12.023,0,0,1,7.655,1.7.8.8,0,0,0,.957,0c1.063-.744,2.127-1.382,3.3-2.127Z",
    transform: "translate(-0.819 -0.669)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.083,20.233c0,.532-.425.532-.851.638a59.65,59.65,0,0,0-6.273.638,31.686,31.686,0,0,0-18.5,10.739c-.319.319-.638.638-1.063.319-.425-.425-.213-.744,0-1.17a30.846,30.846,0,0,1,10.1-7.974A33.308,33.308,0,0,1,32.126,19.6c.425,0,.851,0,.957.638Z",
    transform: "translate(-0.741 -0.575)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.262,7.965h1.276c.744,0,.851.213.851.957a6.412,6.412,0,0,1-2.339,5,10.327,10.327,0,0,1-6.061,2.233,6.54,6.54,0,0,0-1.382.106c-.532,0-.744-.213-.744-.851a8.144,8.144,0,0,1,6.8-7.443,8.048,8.048,0,0,0,1.595-.106Zm-7.017,7.124a11.8,11.8,0,0,0,5.742-1.808A4.71,4.71,0,0,0,27.9,10.517c.106-.425.106-.744.213-1.17C23.859,8.922,20.988,11.262,20.244,15.089Z",
    transform: "translate(-0.554 -0.747)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.19,24.853A28.042,28.042,0,0,0,13.221,32.19c-.106.106-.319.319-.425.319a1.809,1.809,0,0,1-.744-.106.872.872,0,0,1,0-.744c0-.106.213-.319.319-.425,5.635-4.891,12.015-7.655,19.564-7.655h.532c.425,0,.744.213.638.638,0,.213-.425.532-.638.532H31.3Z",
    transform: "translate(-0.655 -0.516)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7,12.35a22,22,0,0,1-.425,2.339.552.552,0,0,1-.851.532c-2.445-.957-4.359-2.445-5-5.1a7.31,7.31,0,0,1,.213-3.4c.106-.532.425-.638.957-.532A6.166,6.166,0,0,1,17.7,12.35Zm-5-4.785c-.851,2.764.957,5.21,3.509,6.167C16.952,10.861,15.464,8.1,12.7,7.565Z",
    transform: "translate(-0.665 -0.772)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.237,3.922a5.532,5.532,0,0,1-1.7,4.253,6.312,6.312,0,0,1-1.914,1.382.667.667,0,0,1-.851-.213c-1.808-3.19-1.17-6.38,1.914-8.081.532-.319,1.382-.744,1.7,0a10.217,10.217,0,0,1,.744,2.127v.425h0ZM19.622,8.175a.424.424,0,0,0,.425-.213,4.529,4.529,0,0,0,1.7-5.21.339.339,0,0,0-.319-.319H21a4.243,4.243,0,0,0-1.7,5.316.34.34,0,0,0,.319.319h0Z",
    transform: "translate(-0.57 -0.85)",
    fill: "#36364a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.671,27.456h1.382c.425,0,.957,0,.957.638s-.532.638-.957.532a18.539,18.539,0,0,0-8.931,1.595,28.566,28.566,0,0,0-3.4,2.02c-.425.213-.744.532-1.17.106-.425-.532,0-.851.319-1.063a19,19,0,0,1,8.506-3.615,31.5,31.5,0,0,1,3.3-.319h0Z",
    transform: "translate(-0.562 -0.461)",
    fill: "#36364a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCulturasAgricolas);
export default __webpack_public_path__ + "static/media/culturas_agricolas.0fa30aed68617b2620ef6c25b415de28.svg";
export { ForwardRef as ReactComponent };